import {PANELMANAGER_SET_SCROLLPOSITION} from '../../constants';

export type SetScrollPositionAction = {
    type : typeof PANELMANAGER_SET_SCROLLPOSITION;
    scrollPosition : number
}

/**
 * @memberOf! Actions
 *
 * @param {number} scrollPosition
 *
 * @return {SetScrollPositionAction}
 */
const setScrollPosition = ( scrollPosition : number ) : SetScrollPositionAction => {
    return {
        type: PANELMANAGER_SET_SCROLLPOSITION,
        scrollPosition
    };
}
export type SetScrollPosition = typeof setScrollPosition;

export default setScrollPosition;
